export default __webpack_public_path__ + "static/media/undraw01.31dd916d.svg";